export const primaryLight = "white";
export const secondaryLight = "#1D1F22";
export const buttonLight = "#2ea44f";
export const headerLight = "white";

export const primaryDark = "#1D1F22";
export const secondaryDark = "#E5E5E5";
export const buttonDark = "#1A9DDE";
export const headerDark = "black";
